module.exports = {
    SECRETS_API_URL: 'https://7quqhtqva1.execute-api.us-east-1.amazonaws.com/prod/getSecrets',
    UPSERT_NOTIFICATION_API_URL: 'https://peobo583z2.execute-api.us-east-1.amazonaws.com/prod/upsertNotification',
    LIST_NOTIFICATIONS_API_URL: 'https://peobo583z2.execute-api.us-east-1.amazonaws.com/prod/listNotifications',
    DELETE_NOTIFICATION_API_URL: 'https://peobo583z2.execute-api.us-east-1.amazonaws.com/prod/deleteNotification',
    LIST_PRODUCTS_API_URL: 'https://peobo583z2.execute-api.us-east-1.amazonaws.com/prod/listProducts',
};